// extracted by css-extract-rspack-plugin
export default {"metroStation":"metro-station--yj9jpC4_wl4vzWl6"};